import deliveryFontRegular  from './fonts/Delivery_W_Rg.woff';

export const BASE_FONT_SIZE = 16;

export const theme = {
  palette: {
    primary: {
      light: "#eb131e",
      main: "#d40511",
      dark: "#9a0000",
    },
    secondary: {
      light: "#ffffff",
      main: "#ffcc00",
      dark: "#e37729",
    },
  },
  typography: {
    fontFamily: 'deliveryFontRegular, Arial',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'deliveryFontRegular';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Delivery'), local('Delivery-Regular'), url(${deliveryFontRegular}) format('woff');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }   
      `,
    },
  },
};
